/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Add_Users_ConfirmInputs */



/**
* | output |
* | --- |
* | "Update users" |
*
* @param {Team_Manager_Add_Users_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_add_users_confirm = /** @type {((inputs?: Team_Manager_Add_Users_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Add_Users_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mettre à jour")
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktualisieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiorna utenti")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обновить")
	if (locale === "es") return /** @type {LocalizedString} */ ("Actualizar usuarios")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("更新用户")
	if (locale === "ja") return /** @type {LocalizedString} */ ("更新")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अपडेट करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Atualizar utilizadores")
	return /** @type {LocalizedString} */ ("Update users")
});